import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import { useLocation, Link } from 'react-router-dom';

function EditOrders() {

    const userID = sessionStorage.getItem("TRCUserId");
    
    const location = useLocation();
    const [productData, setProductData] = useState([]);
    const [clientData, setClientData] = useState([]);

    const [qty, setQty] = useState('');
    const [selectedProduct, setProduct] = useState('');
    const [cartError, setCartError] = useState(false);
    const [error, setError] = useState('');
    const [cartItems, setCartItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [gst, setGST] = useState(0);
    const [orderError, setOrderError] = useState(false);
    const [errorClient, setClientError] = useState('');
	const [crates, setCrates] = useState(0);
	const [weight, setWeight] = useState(0);
	const [counts, setCounts] = useState(0);
    const [dealerData, setDealerData] = useState('');
    const [inputData, setinputData] = useState('');
    const [orderData, setOrderData] = useState(null);
    const [orderId, setOrderId] = useState(null);
	const [inputType, setinputType] = useState('crates');
    const [routes, setRoutes] = useState('');
    const [zones, setZones] = useState('');
    const [shipping, setShipping] = useState(null);
    const [shippingAddress, setShippingAddress] = useState(null);
    const [selectedProductName, setProductName] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        const product = productData?.filter(products => products.id === selectedProduct);
        setProductName(product[0]?.productName);
    },[selectedProduct]);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
		return formattedDate;
	};

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
        
    useEffect(() => {
        const orderid = getQueryParam('id');
        setOrderId(orderid);
    }, [location.search]);


    const getOrder = async () => {
        try {
                const response = await axios.post(
                    'https://api.trucoo.in/orders/order-details/',
                    { orderId },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-KEY': 'erpTrucoo'
                        }
                    }
                );

				console.log(response.data.data);

                if (response.data.status === 'success') {
                    sessionStorage.setItem('cartItems', JSON.stringify([]));
					response.data.data.orderData.forEach(items => {
						
						const existingCartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
						const newItem = {
							product: items.item,
							qty: items.qty,
							price: items.price,
							name: items.itemName,
							weight: items.weight,
							unit: items.unit,
							gst: items.gst,
							crates: items.crates,
                            type: items.type,
                            hsn: items.itemHsn,
                            code: items.itemCode,
                            inputs: items.inputs
						}
						
						existingCartItems.push(newItem);
						sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
					});

                    setinputData((prevData) => ({
                        ...prevData,
                        ['vehicleNumber']: response.data.data.vNum || '',
                        ['remarks']: response.data.data.remarks || '',
                        ['zone']: response.data.data.dealerData.zone || '',
                        ['route']: response.data.data.dealerData.route || '',
                        ['location']: response.data.data.dealerData.location || '',
                        ['date']: formatDate(response.data.data.orderDate) || '',
                        ['userId']: userID,
                        ['type']: response.data.data.type || '',
                }));
                    setOrderData(response.data.data);
                    setClientData(response.data.data.clientData);
                    setDealerData(response.data.data.dealerData);
                    setShipping(response.data.data.shippingAddress);
                    setShippingAddress(response.data.data.ships);
                    getCart();
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    
    useEffect(() => {
            if (orderId) {
                getOrder();
            }
    }, [orderId]);


    function triggerError() {
        setCartError(true);
        setTimeout(() => {
            setCartError(false);
            setError('');
        }, 2000);
    }



    const getCart = () => {
		const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
		setCartItems(cartItems);
		let crates = 0;
		let ltr = 0;
        let count = 0;
		cartItems.forEach(item => {
			const qty = parseFloat(item.qty);
			const crate = parseFloat(item.crates);
			const weight = parseFloat(item.weight);
	
			crates += qty;
			ltr += ((qty * crate * weight)/1000);
            count += (qty * crate);
		});
		
		setCrates(crates);
		setWeight(ltr);
        setCounts(count);
	};


    const getProducts = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/products/all-product/', {userId: userID}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });


            if(response.data.status === 'success'){
                setProductData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getZone = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/zone/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setZones(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getRoutes = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/routes/view/',{}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			if(response.data.status === 'success'){
				setRoutes(response.data.routes);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

    useEffect(() => {
        getRoutes();
        getProducts();
        getCart();
        getZone();
    },[]);


    const newData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
          ...prevData,
          [name]: value,
          ['userId']: userID
        }));
    };


    const changeQty = (e) => {
        const qtys = e.target.value;
        setQty(qtys);
    };


    const changeQtyBtn = (calc) => {
        if(calc === 'plus'){
            setQty(parseFloat(qty)+1);
        }else{
            if(qty === 0){
                setQty(qty);
            }else{
                setQty(parseFloat(qty)-1);
            }
        }
    };

    const focusAndSelectInput = () => {
    	if (inputRef.current) {
      		inputRef.current.focus();
      		inputRef.current.select();
    	}
  	};

    const addCart = () => {

		if(selectedProduct === '' || !selectedProduct){
			setError('Please select product');
			triggerError();
		}else{

			if(qty === 0 || !qty){
				setError('Please select quantity atleast 1');
				triggerError();
			}else{

				const existingCartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
				const existingItemIndex = existingCartItems.findIndex(item => item.product === selectedProduct);

				if (existingItemIndex !== -1) {
					const crates = parseFloat(existingCartItems[existingItemIndex].crates);
					const weight = parseFloat(existingCartItems[existingItemIndex].weight);
					const onecrate = (crates * weight) / 1000;
					let qtyin = 0;
					if(inputType === 'ltr'){
						qtyin = qty / onecrate;
					}else{
						qtyin = qty;
					}
					const newQty = parseFloat(existingCartItems[existingItemIndex].qty) + parseFloat(qtyin);
					if (!isNaN(newQty) && newQty > 0) {
						existingCartItems[existingItemIndex].qty = newQty;
					} else {
						console.log("Invalid quantity");
					}
				}else{

					const product = productData.find((product) => product.id === selectedProduct);
					const price = product ? product.productPrice : null;
					const name = product ? product.productName : null;
					const productWeight = product ? product.productWeight : 0;
					const productUnit = product ? product.unit : null;
					const productGst = product ? product.productGst : null;
					const crates = product ? product.grade : 0;
					const type = product ? product.type : 0;
					const hsn = product ? product.productHsn : 0;
					const code = product ? product.productCode : 0;
                    const inputs = inputType;
					const oneCrate = (parseFloat(crates) * parseFloat(productWeight)) / 1000;

					let qtyin = 0;
					if(inputType === 'ltr'){
						qtyin =  qty /oneCrate;
					}else{
						qtyin = qty;
					}

					const newItem = {
						product: selectedProduct,
						qty: qtyin,
						price: price,
						name: name,
						weight: productWeight,
						unit: productUnit,
						gst: productGst,
						crates: crates,
                        type: type,
                        hsn: hsn,
                        code: code,
                        inputs: inputs
					};

					existingCartItems.push(newItem);
				}

				sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
				getCart();
			}
		}
		setQty('');
		setProduct('');
		setProductName('');
        focusAndSelectInput();
	};

    const removeItem = (id) => {
        const updatedCartItems = cartItems.filter(item => item.product !== id);
        sessionStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
        getCart();
    };

    const updateQty = (productId, delta) => {
        const updatedItems = cartItems.map(item => {
            if (item.product === productId) {
                const newQty = Math.max(1, parseFloat(item.qty) + delta); 
                return { ...item, qty: newQty };
            }
            return item;
        });
        sessionStorage.setItem('cartItems', JSON.stringify(updatedItems));
        getCart();
    };

    const chnageQty = (productId, value) => {

        if (value === '' || parseFloat(value) <= 0) {
            setError('Quantity must be greater than 0');
            triggerError();
            return;
        }

        const updatedItems = cartItems.map(item => {
            if (item.product === productId) {
                return { ...item, qty: parseFloat(value) };
            }
            return item;
        });

        sessionStorage.setItem('cartItems', JSON.stringify(updatedItems));
        getCart();
    };

    const updateOrder = async () => {
        const updatedItems = cartItems.map(item => ({
            product: item.product,
            qty: item.qty,
            price: item.price,
            name: item.name,
            weight: item.weight,
            unit: item.unit,
            gst: item.gst,
			crates: item.crates,
            code: item.code,
            type: item.type,
            hsn: item.hsn,
            inputs: item.inputs
        }));
    
        const payload = {
            orderId,
            dealerId: orderData?.dealerData?.id,
            userId:userID,
            evNum:orderData.evNum,
            VNum: inputData?.vehicleNumber,
            remarks: inputData?.remarks,
            zone: inputData?.zone,
            route: inputData?.route,
            location: inputData?.location,
            date: inputData?.date,
            ships: shippingAddress,
            type: inputData?.type,
            items: updatedItems
        };
    
        try {
            const response = await axios.post(
                'https://api.trucoo.in/orders/edit/', 
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                }
            );
    
            if (response.data.status === 'success') {
                alert("Order updated successfully.");
				sessionStorage.setItem('cartItems', JSON.stringify([]));
                getOrder(); 
            } else {
                alert("Update failed. Try again.");
            }
        } catch (error) {
            console.error("Update error:", error);
            alert("Something went wrong.");
        }
    };
    
//    console.log(cartItems);

   
return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">
                <div class="box box-body">
                    
                    <div class="row">
                       
                        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-12">
                            <div class="box">
                                <div class="box-body">

                                    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Edit Order</h4>
                                    <hr class="my-15" />

                                    <div class="row">
                                        {/* <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="form-label">Select Product</label>
                                                <select className="form-select" name="product" value={selectedProduct} onChange={(e)=> setProduct(e.target.value)} required >
                                                    <option value="" hidden>Select Product</option>
                                                    {productData?.map((product, index) => 
                                                        <option value={product.id}>{product.productName}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

										<div class="col-md-12" align="center">
											<div class="input-group" >
												<button class={`btn btn-sm ${inputType === 'crates' ? 'btn-primary' : 'btn-secondary'} mt-2 mb-2 w-100`} onClick={()=> setinputType('crates')}>Crates</button>
												<button class={`btn btn-sm ${inputType === 'ltr' ? 'btn-primary' : 'btn-secondary'} mt-2 mb-2 w-100`} onClick={()=> setinputType('ltr')}>Litre</button>
											</div>
										</div>

                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label class="form-label">{inputType === 'crates' ? 'Crates' : 'Litre'}</label>
                                                <div class="input-group">
                                                    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('minus')}}>-</button>
                                                    <input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="phone" value={qty} onChange={changeQty} required />
                                                    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('plus')}}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mt-4" align="right">
                                            {cartError && <p class="text-danger">{error}</p> }
                                            <button type="button" class="btn btn-primary btn-sm mt-2" onClick={addCart}>Add Item</button>
                                        </div> */}

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="form-label">Selected Client</label>
                                                <div className="select-container">
                                                    <button  className='form-control mt-2 bg-primary'>
                                                        {dealerData.dealer} 
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Date</label>
												<input type='date' name='date' class='form-control' value={inputData.date} onChange={(e)=>newData(e)} />
									        </div>
										</div>

                                        <div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Zone</label>
												<select class="form-select" name="zone" value={inputData.zone} onChange={(e)=>newData(e)}>
													<option value="">Select a zone</option>
													{zones && zones?.map((data, index)=>
														<option key={index} value={data.id}>{data.zone}</option>
													)}
												</select>
									        </div>
										</div>

                                        <div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Route</label>
												<select class="form-select" name="route" value={inputData.route} onChange={(e)=>newData(e)}>
													<option value="">Select a route</option>
													{routes && routes?.map((route, index)=>
														<option key={index} value={route.id}>{route.route}</option>
													)}
												</select>
									        </div>
										</div>

                                        <div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Place</label>
												<select class="form-select" name="location" value={inputData.location} onChange={(e)=>newData(e)}>
													<option value="">Select a route</option>
													{inputData.route && routes && routes?.find(loc => loc.id === inputData.route)?.locations?.map((location, index)=>
														<option key={index} value={location.id}>{location.location}</option>
													)}
												</select>
									        </div>
										</div>

                                        {shipping?.length > 0 && 
											<div class="form-group">
                    							<label>Select Shipping Address</label>
                    							{shipping?.map(adrs => 
                    								<div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${shippingAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
				        								<input type="radio" id={adrs.id} name="modeOfPayment" value={adrs.id} checked={shippingAddress === adrs.id ? true : false} onChange={(e)=> setShippingAddress(e.target.value)} />
				        								<label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
                    								</div>
                    							)}
                							</div>
										}

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="form-label">Vehicle Number</label>
                                                <input type="text" className="form-control" name="vehicleNumber" value={inputData?.vehicleNumber || ''} onChange={newData} />
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="form-label">Remarks</label>
                                                <textarea className="form-control" name="remarks" value={inputData?.remarks || ''} onChange={newData} rows="3"></textarea>
                                            </div>
                                        </div>

                                       

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-12">
                            <div class="box">
                                <div class="box-body">
                                    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Order Info</h4>
                                    <hr class="my-15" />
                                    <div class="row">
                                        <div class="col-md-12">
											<div class="row">
												<div class="col-md-12 mb-3">
													<div class="form-group">
													<label class="form-label">Type</label>
													<div class="input-group" >
														<button class={`btn btn-sm ${inputType === 'crates' ? 'btn-success' : 'btn-secondary'}`} style={{padding: '5px 25px'}} onClick={()=> setinputType('crates')}>Crates</button>
														<button class={`btn btn-sm ${inputType === 'ltr' ? 'btn-success' : 'btn-secondary'}`} style={{padding: '5px 25px'}} onClick={()=> setinputType('ltr')}>Litre</button>
													</div>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label class="form-label">Select Product</label>
														<input className="form-control" ref={inputRef} type="text" list="products" placeholder="Search Product" value={selectedProductName} onChange={(e)=> setProduct(e.target.value)} required />
														<datalist id="products">
															{productData?.map((product, index) => 
																<option key={index} value={product.id}>{product.productName}</option>
															)}
														</datalist>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label class="form-label">{inputType === 'crates' ? 'Crates' : 'Litre'}</label>
														<div class="input-group">
															{/* <button type="button" class="btn btn-sm btn-info" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('minus')}}>-</button> */}
															<input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="phone" value={qty} onChange={changeQty} required />
															{/* <button type="button" class="btn btn-sm btn-info" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('plus')}}>+</button> */}
														</div>
													</div>
												</div>

												
												<div class="col-md-2 mt-4">
													{cartError && <p class="text-danger">{error}</p> }
													<button type="button" class="btn btn-sm btn-success  mt-2"  onClick={addCart}>Add Item</button>
												</div>
											</div>
										</div>
										<hr />
                                    {cartItems.length > 0 ?
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th width="33%">Product</th>
                                                    <th width="17%">Crates</th>
                                                    <th width="15%">Qty</th>
                                                    <th width="15%">LTR/KG</th>
                                                    <th width="15%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cartItems?.map((product, index) => 
                                                <tr>
                                                    <td>{product.name}</td>
                                                    <td>
                                                        <div className="input-group input-group-sm">
                                                            <button className="btn btn-danger btn-sm" onClick={() => updateQty(product.product, -1)}>-</button>
                                                            <input type="text" className="form-control text-center" value={product.qty} onChange={(e)=>chnageQty(product.product, e.target.value)} />
                                                            <button className="btn btn-success btn-sm" onClick={() => updateQty(product.product, 1)}>+</button>
                                                        </div>
                                                    </td>

                                                    <td>{parseFloat(product.qty).toFixed(2)}</td>
                                                    <td>{(parseFloat(product.crates) * parseFloat(product.qty) * (parseFloat(product.weight) / 1000)).toFixed(2)}</td>
                                                    <td class="table-action min-w-100">
                                                        <button class="form-control text-fade hover-primary" onClick={() => removeItem(product.product)}><i class="fa fa-trash"></i></button>
                                                    </td>
                                                </tr>
                                                )}
                                                <tr>
													<th>Total</th>
													<th>{parseFloat(crates).toFixed(2)}</th>
													<th>{parseFloat(counts).toFixed(2)}</th>
													<th>{parseFloat(weight).toFixed(2)}</th>
												</tr>
												
                                            </tbody>
                                        </table>
                                        :
                                        <div align="center" class="mt-4 mb-4"> <p>Add Items</p></div>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
                                    <div class="box-footer" align="center">
                                        {orderError && <p class="text-danger">{errorClient}</p>}
                                        <button class="btn btn-primary" onClick={updateOrder} ><i class="fa fa-shopping-cart"></i> Update Order</button>
                                    </div>  
                        
                                </div>
                            </div>
                        </div>
                     
                    </div>
                
                </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default EditOrders;